import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustBadges from "@/components/TrustBadges";
import MarqueeStrip from "@/components/MarqueeStrip";
import TrustIndicators from "@/components/TrustIndicators";
import ClaimTypes from "@/components/ClaimTypes";
import Process from "@/components/Process";
import WhyChooseUs from "@/components/WhyChooseUs";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";

export default function Landing() {
  return (
    <main className="bg-background">
      <Navbar />
      <Hero />
      <TrustBadges />
      <MarqueeStrip />
      <TrustIndicators />
      <ClaimTypes />
      <Process />
      <WhyChooseUs />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <FloatingContact />
    </main>
  );
}
